import React, { useEffect, useState } from "react";
import CustomHeading from '../../../constants/CustomHeading'
import {  Formik, Form} from 'formik';
import * as Yup from 'yup';
import CustomInput from '../../../constants/CustomInput';
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomButton from '../../../constants/CustomButton';
import CustomRichTextField from "../../../constants/CustomRichTextField";
import CustomTableWithAll from '../../../constants/CustomTableWithAll';
import {connect} from 'react-redux';
import {getprofessionalbodiesData,setprofessionalbodiesData} from '../../../redux/actions/dataAction';
import CustomLine from "../../../constants/CustomLine";


const validationSchema = Yup.object().shape({
    organization_name: Yup.string()
    .required('Required'),
    membership_type: Yup.string()
    .required('Required'),
    membership_no: Yup.string()
    .required('Required'),
    start_date: Yup.string()
    .required('Required'),
 
});
const Scholarship = (props) => {
    const [isLoading,setIsLoading]=useState(false);
    useEffect(()=>{
        props.getprofessionalbodiesData();
    },[isLoading])
    const columns = [ 
        {title:'Organization Name',field:'organization_name'},
        {title:'Membership type',field:'membership_type', lookup: { LifeTime: 'Life Time', Annual: 'Annual' } },
        {title:'Membership No',field:'membership_no'},
        {title: "Date",field:"start_date",type:Date()},
      ]
  return (
    <div className="customContainer">
        <CustomHeading title="Professional Bodies"/>
        <CustomTableWithAll data={props?.professional_bodies?.data}  columns={columns} api="/api/professional_bodies/"  title={'All Professional Bodies'} />
        <CustomLine/>
        <Formik 
                initialValues={{
                    organization_name:'',
                    membership_type:'',
                    membership_no:'',
                    start_date:'',
                    description:'',
                   }}
                   validationSchema={validationSchema}
                   onSubmit={values => {
                    props.setprofessionalbodiesData(values);
                    setIsLoading(true);
                    
                  }}
            >
            {({ errors, touched,handleChange,handleSubmit }) => (
            <Form onSubmit={handleSubmit} style={{marginTop:0}}>
                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        label={'Organization Name :'}
                        onChange={handleChange('organization_name')}
                        errorText={
                            errors.organization_name && touched.organization_name ?errors.organization_name :null
                        }
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        label={'Membership No. :'}
                        onChange={handleChange('membership_no')}
                        errorText={
                            errors.membership_no && touched.membership_no ?errors.membership_no :null
                        }
                    />
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'date'}
                        label={'Date :'}
                        onChange={handleChange('start_date')}
                        errorText={
                            errors.start_date && touched.start_date ?errors.start_date :null
                        }
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomDropdown 
                            label="Membership Type : "
                            data={[{value:"LifeTime"},{value:"Annual"}]}
                            onChange={handleChange('membership_type')}
                            errorText={
                                errors.membership_type && touched.membership_type ?errors.membership_type :null
                            }
                        />
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-md-6">
                        <CustomRichTextField label={'Description'} onChange={handleChange('description')}/>
                    </div>
                    <div className="col-md-2 my-3">
                    <CustomButton type="submit" label="Save" isIcon/>
                    </div>
                </div>
             </Form>
              )}
            </Formik>
    </div>
  );
};
const mapActionWithProps = {
    getprofessionalbodiesData,
    setprofessionalbodiesData
  }
  
  const mapStateWithProps = (state)=>(
    {
        professional_bodies:state.data.professional_bodies
    }
  )
  export default connect(mapStateWithProps,mapActionWithProps)(Scholarship);
